import {
  TableContainer as MuiTableContainer,
  TableContainerProps as MuiTableContainerProps,
  TableRow as MuiTableRow,
  TableRowProps as MuiTableRowProps,
  TableCell as MuiTableCell,
  TableCellProps as MuiTableCellProps,
  TablePaginationProps as MuiTablePaginationProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTableContainer = styled(
  MuiTableContainer
)<MuiTableContainerProps>(
  ({ theme: { palette, spacing, colors, customVars } }) => ({
    padding: spacing(0, 0.2),
    borderRadius: spacing(0.4, 0.4, 0, 0),

    /** Table */
    '& .MuiTable-root': {
      backgroundColor: palette.background.default,
    },

    /** Table Cell */
    '& .MuiTableCell-root': {
      border: 'none',
    },

    /** Table Head Row */
    '& .MuiTableHead-root .tableHead-row': {
      height: spacing(5.6),
      backgroundColor: colors.tableHeader,
    },

    /** Table Body Row */
    '& .MuiTableBody-root .tableBody-row': {
      boxShadow: customVars.dropDownShadow,
    },

    /** Table Body Disabled Row */
    '& .MuiTableBody-root .disabledRow.tableBody-row .MuiTableCell-root': {
      color: palette.action.disabled,
    },
  })
);

export const StyledHead = styled('div')({
  display: 'flex',
  alignItems: 'center',
  maxWidth: 'fit-content',
  wordBreak: 'break-word',
});

export const CheckboxCell = styled(MuiTableCell)<MuiTableCellProps>(
  ({ theme: { spacing } }) => ({
    padding: spacing(0.8, 0.8, 0.8, 1.6),
  })
);

export const PaginationStyles: MuiTablePaginationProps['sx'] = {
  '& .MuiToolbar-root': {
    minHeight: '3.6rem',
    margin: '1.6rem 5rem 0.2rem 0',
  },

  /** Pagination Labels */
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    margin: '0',
  },

  /** Pagination Select */
  '& .MuiInputBase-root.MuiSelect-root': {
    minWidth: '7.7rem',
    minHeight: '3.6rem',
    margin: '0 2.4rem 0 0.8rem',
    border: '0.1rem solid',
    borderColor: ({ colors }) => colors.container,
    borderRadius: '0.4rem',

    '& .MuiSelect-select': {
      padding: '0.6rem 4.2rem 0.6rem 1.6rem',
      backgroundColor: 'background.paper',
    },

    '& .MuiSvgIcon-root': {
      right: '1.2rem',
    },
  },
};

export const LoaderRow = styled(MuiTableRow)<MuiTableRowProps>({
  display: 'table',
  position: 'absolute',
  top: '0',
  width: '100%',
  height: '100%',
  zIndex: 11,
});
